var render = function render(){var _vm=this,_c=_vm._self._c;return _c('pc-client-side-navigation-item',{attrs:{"id":"userSettingsNavigationItem","icon":"pc-entity-user","title":"User settings","selected":_vm.activeItem == 'userSettings',"to":"/user-settings","no-tooltips":_vm.sideMenuIsExpanded,"data-id":"9d4f13c7e08b42a6b719fc35a8e2d06b"}})
}
var staticRenderFns = []

export { render, staticRenderFns }